import { render, staticRenderFns } from "./PointeConsultations.vue?vue&type=template&id=48490d60&scoped=true"
import script from "./PointeConsultations.vue?vue&type=script&lang=js"
export * from "./PointeConsultations.vue?vue&type=script&lang=js"
import style0 from "./PointeConsultations.vue?vue&type=style&index=0&id=48490d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48490d60",
  null
  
)

export default component.exports